
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdershippingBooksDialog extends Serenity.EntityDialog<OrdershippingBooksRow, any> {
        protected getFormKey() { return OrdershippingBooksForm.formKey; }
        protected getIdProperty() { return OrdershippingBooksRow.idProperty; }
        protected getLocalTextPrefix() { return OrdershippingBooksRow.localTextPrefix; }
        protected getService() { return OrdershippingBooksService.baseUrl; }
        protected getDeletePermission() { return OrdershippingBooksRow.deletePermission; }
        protected getInsertPermission() { return OrdershippingBooksRow.insertPermission; }
        protected getUpdatePermission() { return OrdershippingBooksRow.updatePermission; }

        protected form = new OrdershippingBooksForm(this.idPrefix);

    }
}